export class FormatDateTimeHelper {
  dayMonthRegex = /^(0?[1-9]|[12]\d|3[01])(-|\/|\s)(0?[1-9]|1[0-2])$/;
  fullDateRegex = /^(20\d{2})(-|\/)(0?[1-9]|1[0-2])(-|\/)(0?[1-9]|[1-2]\d|3[0-1])$/;
  shortfullDateRegex = /^([2-3]\d)(-|\/|\s)?(0[1-9]|1[0-2])(-|\/|\s)?(0[1-9]|[1-2]\d|3[0-1])$/;
  timeRegex = /^(0?[0-9]|1[0-9]|2[0-3])(:?)([0-5][0-9])?$/;
  replaceSlashesAndWhiteSpacesRegex = /\/|\s/g;
  removeSlahesHyphensWhiteSpacesRegex = /(-|\/|\s)/g;

  validateDate(dateString) {
    if (this.fullDateRegex.test(dateString)) {
      dateString = this.replaceSlashesAndWhiteSpacesWithHyphens(
        dateString
      );
      dateString = this.checkDate(dateString);
      return dateString;
    } else if (this.shortfullDateRegex.test(dateString)) {
      return this.formatShortFullDateToProperTimeString(dateString);
    } else if (this.dayMonthRegex.test(dateString)) {
      //Formats the day/month string into a proper date string.
      return this.formatDayMonthToProperDateString(dateString);
    }
    return false;
  }

  validateTime(timeString) {
    if (this.timeRegex.test(timeString)) {
      return this.formatTime(timeString);
    }
    return false;
  }

  formatShortFullDateToProperTimeString(shortFullDate) {
    // Removes slashes, hyphens and white spaces from the date string.
    shortFullDate = shortFullDate.replace(
      this.removeSlahesHyphensWhiteSpacesRegex,
      ""
    );

    // Extracts the different parts and joins it into a proper date string.
    let year = shortFullDate.substring(0, 2);
    let month = shortFullDate.substring(2, 4);
    let date = shortFullDate.substring(4);
    return this.checkDate(`20${year}-${month}-${date}`);
  }

  formatDayMonthToProperDateString(date) {
    let tempArray = [];
    tempArray = this.convertDateStringToArray(date);

    //Switch place so month comes before day.
    let temp = tempArray[0];
    tempArray[0] = tempArray[1];
    tempArray[1] = temp;

    //Adds in the year to the date string, since it is missing in this case.
    tempArray.unshift(new Date().getFullYear());

    //Check if the date that has been chosen is this year or next year.
    //If the date chosen comes before the day's date, we assume they mean next year.
    if (Date.now() > new Date(tempArray.join("-")).getTime()) {
      let lastYear = parseInt(tempArray.shift());
      tempArray.unshift(lastYear + 1);
    }
    tempArray = this.addZeroToSingleNumbers(tempArray);
    let dateString = tempArray.join("-");
    dateString = this.checkDate(dateString);
    return dateString;
  }

  formatTime(timeString) {
    if (timeString.includes(":")) {
      timeString = timeString.replace(":", "");
    }

    switch (timeString.length) {
      case 1:
        timeString = timeString.padStart(2, "0").padEnd(5, ":00");
        return timeString;
      case 2:
        return timeString.padEnd(5, ":00");
      case 3:
        return this.addColonToStringOnIndex(timeString.padStart(4, "0"), 2);
      case 4:
        return this.addColonToStringOnIndex(timeString, 2);
    }
  }

  changeToPreviousDay(currentDateString) {
    let today = new Date(currentDateString);
    let yesterday = new Date(today.setDate(today.getDate() - 1));
    return yesterday.toISOString().slice(0, 10);
  }

  changeToNextDay(currentDateString) {
    let today = new Date(currentDateString);
    let tomorrow = new Date(today.setDate(today.getDate() + 1));
    return tomorrow.toISOString().slice(0, 10);
  }

  // ----- Help methods below ----- //

  // Check if the date actually exist, for example, 2020-06-31 does not exist.
  // We need to convert it to 2020-07-01 in this case.
  checkDate(dateString) {
    return new Date(dateString).toISOString().slice(0, 10);
  }

  // Converts the date string into an array.
  convertDateStringToArray(str) {
    let tempArray = [];
    str = this.replaceSlashesAndWhiteSpacesWithHyphens(str);
    tempArray = str.split("-");
    return tempArray;
  }

  // Replaces the slashes, if present, with hyphens.
  replaceSlashesAndWhiteSpacesWithHyphens(dateString) {
    return dateString.replace(this.replaceSlashesAndWhiteSpacesRegex, "-");
  }
  // Adds a "0" before any single number if it does not exist, in order to display the date properly.
  addZeroToSingleNumbers(array) {
    array = array.map((e, i) => {
      return i != 0 ? e.padStart(2, 0) : e;
    });
    return array;
  }

  addColonToStringOnIndex(str, index) {
    let tempArray = str.split("");
    tempArray.splice(index, 0, ":");
    return tempArray.join("");
  }
}
